<ion-header>
  <ion-toolbar>
    <ion-title>
      Imprimir tickets
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">

  <ion-text class="ion-text-center">
    <p>
      Selecciona los tickets que deseas imprimir
    </p>
  </ion-text>

  <ion-list>
    <ion-item *ngFor="let ticket of generatedTickets">

      <ion-checkbox labelPlacement="start" [(ngModel)]="ticket.selected">
        <div class="label-checkbox-wrapper">
          <h2 class="ion-no-margin">Ticket número: {{ticket.id}}</h2>
          <h3 class="ion-no-margin">Fecha: {{ticket.created | date:'yyyy/MM/dd HH:mm'}}</h3>
          <p class="ion-no-margin" *ngIf="!ticket.printed">Sin imprimir</p>
        </div>
      </ion-checkbox>
    </ion-item>
  </ion-list>
</ion-content>


<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="printTickets()" [disabled]="!anyTicketSelected">
        Imprimir
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>